import FormattedMessage from 'I18n/components/FormattedMessage';
import { AGENT, BOT, SYSTEM, VISITOR } from '../../common-message-format/constants/legacySenderTypes';
import { getSenderType } from '../operators/getters';
import { jsx as _jsx } from "react/jsx-runtime";
export const UnknownSenderText = ({
  sender
}) => {
  const senderType = sender && getSenderType(sender);
  switch (senderType) {
    case BOT:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-message-history.responder.bot"
      });
    case AGENT:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-message-history.responder.unknownResponder"
      });
    case VISITOR:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-message-history.responder.unknownVisitor"
      });
    case SYSTEM:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-message-history.responder.automatic"
      });
    default:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-message-history.responder.unknownSender"
      });
  }
};
UnknownSenderText.displayName = 'UnknownSenderText';